import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { changePassword, ApiError } from '../lib/api';
import { Button, ErrorText } from '../components/ui';

export default function ChangePasswordPage() {
  const { refreshProfile, signOut } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (pw.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (pw !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await changePassword(pw);
      await refreshProfile();
      navigate('/');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Failed to change password');
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold">Set a new password</h1>
        <p className="mt-1 text-sm text-slate-500">
          You must replace your temporary password before continuing.
        </p>
        <div className="mt-4 space-y-3">
          <input
            type="password"
            placeholder="New password"
            autoComplete="new-password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            required
            className="w-full rounded border border-slate-300 px-3 py-2 outline-none focus:border-brand-500"
          />
          <input
            type="password"
            placeholder="Confirm password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="w-full rounded border border-slate-300 px-3 py-2 outline-none focus:border-brand-500"
          />
        </div>
        <ErrorText>{error}</ErrorText>
        <Button type="submit" disabled={busy} className="mt-4 w-full">
          {busy ? 'Saving…' : 'Save and continue'}
        </Button>
        <button
          type="button"
          onClick={async () => {
            await signOut();
            navigate('/login');
          }}
          className="mt-3 w-full text-sm text-slate-400 hover:text-slate-600"
        >
          Sign out
        </button>
      </form>
    </div>
  );
}
